import { StateSelectorProps } from "../types/StateSelectorProps";
import { Autocomplete, TextField } from "@mui/material";

const StateSelector: React.FC<StateSelectorProps> = ({
  stateList,
  onStateChange,
}) => {
  return (
    <Autocomplete
      options={stateList}
      getOptionLabel={(option: any) => option.name}
      onChange={(event, selectedState) => onStateChange(selectedState)}
      size="small"
      renderInput={(params) => (
        <TextField {...params} label="State" variant="outlined" fullWidth />
      )}
    />
  );
};

export default StateSelector;
